export enum EmployeeBenefitStatusEnums {
  VALID = 1,
  VIOLATED = 2, // error
  FUTURE_VIOLATED = 3, // warning
}
